import Vue from 'vue';

export const getUserInfo = (params) => Vue.axios.get('/cooperator/authentication/getUserInfo', { params });

